<template>
  <a-modal
      :title="`${actType}优化师`"
      centered
      :width="720"
      :mask-closable="false"
      :visible="showForm"
      :confirmLoading="loading"
      @cancel="close"
  >
    <a-form-model
      ref="form"
      :model="model"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
    <a-form-model-item label="所属主体" prop="corporation_id">
      <a-select show-search allow-clear placeholder="请选择" v-model="model.corporation_id"  option-filter-prop="children" @change="getjuliangEmails">
        <a-select-option :value="corporation.id" v-for="corporation in corporations" :key="corporation.id" >
          {{ corporation.name }}
        </a-select-option>
      </a-select>
    </a-form-model-item>

      <a-form-model-item label="姓名" prop="username">
        <a-input v-model="model.username"/>
      </a-form-model-item>

      <a-form-model-item label="别名" prop="alias">
        <a-input v-model="model.alias"/>
      </a-form-model-item>

      <a-form-model-item label="身份类型" prop="type">
        <a-select placeholder="请选择" v-model="model.type"  option-filter-prop="children">
          <a-select-option :value="item.id" v-for="item in types" :key="item.id" >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="业务类型" prop="business_type">
        <a-select show-search allow-clear placeholder="请选择" v-model="model.business_type" option-filter-prop="children">
          <a-select-option :value="item.id" v-for="item in businessTypes" :key="item.id" >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      
      <a-form-model-item label="所属小组" prop="team_id">
        <a-select show-search allow-clear placeholder="请选择" v-model="model.team_id"  option-filter-prop="children">
          <a-select-option :value="team.id" v-for="team in teams" :key="team.id" >
            {{ team.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="巨量邮箱" prop="juliang_emails">
        <a-select mode="multiple"  show-search allow-clear placeholder="请选择" v-model="model.juliang_emails"  option-filter-prop="children">
          <a-select-option :value="item" v-for="(item, index) in emails" :key="index" >
            {{ item }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="状态" prop="state">
        <a-select show-search allow-clear placeholder="请选择" v-model="model.state"  option-filter-prop="children">
          <a-select-option :value="item.id" v-for="item in status" :key="item.id" >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="同步素材到巨量组织" prop="is_sync_material">
        <a-switch v-model="model.is_sync_material" checked-children="开启" un-checked-children="关闭" />
      </a-form-model-item>
   
    </a-form-model>
    <template slot="footer">
      <a-button @click="close" :disabled="loading">取消</a-button>
      <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
    </template>
  </a-modal>
</template>

<style lang="less" scoped>
@import 'Create';
</style>

<script>
import Create from './Create'

export default Create
</script>
